module.exports = __webpack_public_path__ + "static/media/itsuki_default7e2bb2ab9a612c5a58707e4981f8e3a2.webp";